import { AuthServiceModule } from 'services/auth/auth.service';

export const LogoutDirectiveModule = angular
    .module('app.directives.logoutDirective', [
        AuthServiceModule
    ]).directive('logout', (auth0AuthService) => {
        return {
            restrict: 'A',
            link: (scope, element) => {
                element.on('click', logout);
                scope.$on('$destroy', () => {
                    element.off('click', logout);
                });

                function logout() {
                    auth0AuthService.logout();
                }
            }
        };
    }).name;


// WEBPACK FOOTER //
// ./src/app/directives/logout.directive.js